export enum DeletePlan {
  Never = 0,
  OnCompletes = 1,
  OnSucceeds = 2,
  OnFails = 3
}
